<template>
  <div class="animated fadeIn">
    <Loader :is-visible="loading" />

    <StatsB2C2BFilters @apply="applyFilters" />

    <div class="card">
      <div class="card-header">
        <i class="fa fa-bar-chart"></i> Statistiques B2C2B
      </div>
      <div class="card-block">
        <p v-if="!workplaces" class="alert alert-info text-center">
          Sélectionnez et appliquez des filtres pour afficher les statistiques
        </p>

        <Tabs v-else v-model="activeTab">
          <Tab :header="prospectsHeader">
            <StatsB2C2BData :workplaces="prospectWorkplaces" />
          </Tab>
          <Tab :header="clientsHeader">
            <StatsB2C2BData :workplaces="clientWorkplaces" />
          </Tab>
        </Tabs>
      </div>
    </div>
  </div>
</template>

<script>
import Tabs from "vue-strap/src/Tabs";
import Tab from "vue-strap/src/Tab";

import StatsB2C2BFilters from "@/components/stats/StatsB2C2BFilters";
import Loader from "@/components/utils/Loader";
import StatsB2C2BData from "@/components/stats/StatsB2C2BData";

export default {
  components: {
    StatsB2C2BFilters,
    StatsB2C2BData,
    Loader,
    Tabs,
    Tab,
  },

  data() {
    return {
      filters: {
        dateKey: "createdAt",
        begin: null,
        end: null,
        b2cCommercials: [],
        b2bCommercials: [],
      },

      loading: false,
      activeTab: 0,
      workplaces: null,
    };
  },

  computed: {
    prospectWorkplaces() {
      return (
        this.workplaces?.filter((w) => w.client?.prospect?.isProspect) || []
      );
    },

    clientWorkplaces() {
      return (
        this.workplaces?.filter(
          (w) => w.client && !w.client.prospect?.isProspect,
        ) || []
      );
    },

    prospectsHeader() {
      return `Prospects (${this.prospectWorkplaces.length})`;
    },

    clientsHeader() {
      return `Clients (${this.clientWorkplaces.length})`;
    },
  },

  methods: {
    applyFilters(filters) {
      this.filters = { ...this.filters, ...filters };

      this.fetchStats();
    },

    async fetchStats() {
      try {
        this.loading = true;

        const { data } = await this.$api.get("/workplaces", {
          params: this.filters,
        });

        this.workplaces = data;
      } catch (e) {
        this.$errorToast("Impossible de récupérer les statistiques B2C2B");

        this.workplaces = null;
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
